import { Text } from "../../../../../packages/ui-kit";
import { CircleLoader } from "../../../../../packages/components";
import { DICTIONARY } from "../../../dictionary";
import styles from "./chat-not-init.module.scss";

export const ChatNotInit = () => {
  const loader = <CircleLoader className={styles.loader} />;

  return (
    <div
      data-test-id="chat-not-init-container"
      className={styles["chat-not-init"]}
    >
      <div>
        {loader}
        <Text>{DICTIONARY.POST_CHAT}</Text>
      </div>
    </div>
  );
};
